// extracted by mini-css-extract-plugin
export default {"tag":"_1rzSnE82","tagRemove":"_1RnXjvWm","input":"_31cmTFsF"};